export const masks = {
    maskPhone: (phone: string | undefined | null) => {
        return phone 
            ? phone
                .replace(/\D/g, "")
                .replace(/^(\d{2})(\d)/g, "($1)$2")
                .replace(/(\d)(\d{4})$/, "$1-$2")
            : ''
    }
} 
  